import React, { useEffect, useState } from 'react';
import { useNavigate } from 'react-router-dom';
import { Store, LogOut, ChevronRight, RefreshCw } from 'lucide-react';
import { useAuth } from '../context/AuthContext';
import { db, ensureDbOpen } from '../db/database';

const StationSelect = () => {
  const [spaces, setSpaces] = useState([]);
  const [isLoading, setIsLoading] = useState(true);
  const navigate = useNavigate();
  const { user, logout, selectStation } = useAuth();

  useEffect(() => {
    loadSpaces();
  }, []);

  const loadSpaces = async () => {
    try {
      await ensureDbOpen();
      const allSpaces = db.spaces
        ? await db.spaces.where('active').equals(1).toArray()
        : [];
      setSpaces(allSpaces);
    } catch (error) {
      console.error('Error loading spaces:', error);
    } finally {
      setIsLoading(false);
    }
  };

  const handleSpaceSelect = (space) => {
    // Internamente seguimos usando selectStation para no romper el contexto existente,
    // pero aquí realmente estamos seleccionando un espacio (primer nivel de spaces-tree)
    selectStation(space);
    navigate('/nodes');
  };

  const handleLogout = () => {
    const shouldLogout = window.confirm('¿Seguro que deseas cerrar sesión?');
    if (!shouldLogout) return;
    logout();
    navigate('/');
  };

  if (isLoading) {
    return (
      <div className="min-h-screen bg-gradient-to-br from-gray-900 via-purple-900 to-blue-900 flex items-center justify-center">
        <div className="text-white text-xl">Cargando...</div>
      </div>
    );
  }

  return (
    <div className="min-h-screen bg-gradient-to-br from-gray-900 via-purple-900 to-blue-900 p-4">
      <div className="max-w-2xl mx-auto pt-8">
        <div className="flex justify-between items-center mb-8">
          <div>
            <h1 className="text-3xl font-bold text-white mb-2">
              Bienvenido, {user?.name}
            </h1>
            <p className="text-gray-300">Selecciona tu espacio de trabajo</p>
          </div>
          <div className="flex gap-3">
            <button
              onClick={() => navigate('/connect')}
              className="p-3 bg-blue-600 hover:bg-blue-700 rounded-lg text-white transition-colors"
            >
              <RefreshCw size={22} />
            </button>
            <button
              onClick={handleLogout}
              className="p-3 bg-red-600 hover:bg-red-700 rounded-lg text-white transition-colors"
            >
              <LogOut size={24} />
            </button>
          </div>
        </div>

        <div className="space-y-4">
          {spaces.map((space) => (
            <button
              key={space.id}
              onClick={() => handleSpaceSelect(space)}
              className="card w-full p-6 hover:border-primary-500 transition-all flex items-center justify-between group"
            >
              <div className="flex items-center space-x-4">
                <div className="w-14 h-14 bg-gradient-to-br from-primary-500 to-secondary-500 rounded-xl flex items-center justify-center">
                  <Store size={28} className="text-white" />
                </div>
                <div className="text-left">
                  <h3 className="text-xl font-semibold text-white">
                    {space.name}
                  </h3>
                  <p className="text-gray-400 text-sm">Toca para seleccionar</p>
                </div>
              </div>
              <ChevronRight 
                size={28} 
                className="text-gray-400 group-hover:text-primary-400 transition-colors" 
              />
            </button>
          ))}
        </div>

        {spaces.length === 0 && (
          <div className="card p-8 text-center">
            <p className="text-gray-400">No hay espacios disponibles</p>
          </div>
        )}
      </div>
    </div>
  );
};

export default StationSelect;
